export default __webpack_public_path__ + "static/media/060_corner2.594e274e.mp4";